import { graphql } from 'react-apollo';
import log from 'chameleon/ui-stack/utilities/log';

import { getAssessmentLFocusLinks } from 'legacy-packages/unit-outline/src/queries';
import { unitsClient } from 'legacy-src/utility/GraphqlClients';

const queryOptions = (props) => {
  const { subject, userData, assignments } = props;
  return {
    client: unitsClient,
    variables: {
      subjectId: subject.id,
      educationPeriod: userData.chosenEducationPeriodCode,
      assessmentId: assignments[0].accNum,
      isTeacher: userData.isTeacher,
    },
    notifyOnNetworkStatusChange: true,
  };
};

const withAssessmentFocusLinks = graphql(getAssessmentLFocusLinks, {
  options: queryOptions,
  props: ({ data }) => ({
    loading: data.loading,
    focusLinks: data.assessmentFocusLinks,
  }),
  error: ({ data: { error } }) => {
    log('error', error);
    return {
      providerError: true,
    };
  },
});

export default withAssessmentFocusLinks;
